/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import _isFunction from 'lodash/isFunction';
import _isArray from 'lodash/isArray';
import _isString from 'lodash/isString';
import _isBoolean from 'lodash/isBoolean';
import _isNumber from 'lodash/isNumber';
import _isNaN from 'lodash/isNaN';

// wrap the lodash functions to avoid having lodash's TS type definition from being
// exported, which can conflict with the lodash namespace if other versions are used

// tslint:disable-next-line:ban-types
export const isFunction = (value: any): value is (...args: any[]) => any =>
  _isFunction(value);
export const isArray = (value: any): value is any[] => _isArray(value);
export const isString = (value: any): value is string => _isString(value);
export const isBoolean = (value: any): value is boolean => _isBoolean(value);
export const isNumber = (value: any): value is number => _isNumber(value);
export const isNaN = (value: any) => _isNaN(value);
try {
    // @ts-ignore
    isFunction.displayName = "isFunction";
    // @ts-ignore
    isFunction.__docgenInfo = { "description": "", "displayName": "isFunction", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/services/predicate/lodash_predicates.ts#isFunction"] = { docgenInfo: isFunction.__docgenInfo, name: "isFunction", path: "src/services/predicate/lodash_predicates.ts#isFunction" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    isArray.displayName = "isArray";
    // @ts-ignore
    isArray.__docgenInfo = { "description": "", "displayName": "isArray", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/services/predicate/lodash_predicates.ts#isArray"] = { docgenInfo: isArray.__docgenInfo, name: "isArray", path: "src/services/predicate/lodash_predicates.ts#isArray" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    isString.displayName = "isString";
    // @ts-ignore
    isString.__docgenInfo = { "description": "", "displayName": "isString", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/services/predicate/lodash_predicates.ts#isString"] = { docgenInfo: isString.__docgenInfo, name: "isString", path: "src/services/predicate/lodash_predicates.ts#isString" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    isBoolean.displayName = "isBoolean";
    // @ts-ignore
    isBoolean.__docgenInfo = { "description": "", "displayName": "isBoolean", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/services/predicate/lodash_predicates.ts#isBoolean"] = { docgenInfo: isBoolean.__docgenInfo, name: "isBoolean", path: "src/services/predicate/lodash_predicates.ts#isBoolean" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    isNumber.displayName = "isNumber";
    // @ts-ignore
    isNumber.__docgenInfo = { "description": "", "displayName": "isNumber", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/services/predicate/lodash_predicates.ts#isNumber"] = { docgenInfo: isNumber.__docgenInfo, name: "isNumber", path: "src/services/predicate/lodash_predicates.ts#isNumber" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    isNaN.displayName = "isNaN";
    // @ts-ignore
    isNaN.__docgenInfo = { "description": "", "displayName": "isNaN", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/services/predicate/lodash_predicates.ts#isNaN"] = { docgenInfo: isNaN.__docgenInfo, name: "isNaN", path: "src/services/predicate/lodash_predicates.ts#isNaN" };
}
catch (__react_docgen_typescript_loader_error) { }